import { useCallback } from 'react';

import { BulkDownloadFiles } from '~/utils/DownloadFile';
import { createImgixImageUrl, extIsSupportedExportFormat } from '~/utils/Imgix';

const BATCH_EXPORT_STAGGER_MS = 300;

export type BatchExportClip = {
  id: string;
  fileName: string;
  width: number;
  height: number;
  imageSrc: string;
};

export type BatchExportImagesParams = {
  scale: string;
  suffix: string;
  format: string;
};

export const useBatchExportImages = () => {
  const exportImages = useCallback((clips: BatchExportClip[], { scale, suffix, format }: BatchExportImagesParams) => {
    if (!extIsSupportedExportFormat(format)) {
      return;
    }

    const scaleMultiplier = Number(scale);

    clips.forEach((clip, index) => {
      const fileName = suffix
        ? `${clip.fileName}_${suffix}_${index + 1}.${format}`
        : `${clip.fileName}_${index + 1}.${format}`;
      const scaledWidth = Math.max(1, Math.round(clip.width * scaleMultiplier));
      const scaledHeight = Math.max(1, Math.round(clip.height * scaleMultiplier));

      const url = createImgixImageUrl({
        imageSrc: clip.imageSrc,
        width: scaledWidth,
        height: scaledHeight,
        format,
        fileName,
      });

      // Intentional fire-and-forget: the modal closes immediately after exportImages() is
      // called, so timeouts must outlive the component. Downloads complete within seconds.
      window.setTimeout(() => {
        BulkDownloadFiles([url]);
      }, index * BATCH_EXPORT_STAGGER_MS);
    });
  }, []);

  return { exportImages };
};
